.toggle {
  display: inline-flex;
  margin: 0;
  padding: 0;
  min-width: 0;
  border: var(--dimension-line-control) solid var(--color-text-primary);
  border-radius: 999px;
  overflow: hidden;
}
.option {
  padding: var(--dimension-space-2) var(--dimension-space-4);
  border: 0;
  background: transparent;
  color: var(--color-text-primary);
  text-transform: uppercase;
  cursor: pointer;
}
.on {
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.inverse {
  border-color: var(--color-text-on-inverse);
}
.inverse .option {
  color: var(--color-text-on-inverse);
}
.inverse .on {
  background: var(--color-text-on-inverse);
  color: var(--color-surface-inverse);
}
